module.exports = __webpack_public_path__ + "static/media/arrow-left.00e9c585.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/DivisionSelector/arrow-left.svg
// module id = 1061
// module chunks = 0